export default {
  title: "Заказ услуг",
  untilDeadline: "Не позднее {date}",
  startDate: "Доступно с {date}",
  servicesOrders: "Мои заказы",

  servicesCartBtn: "Корзина",
  servicesCatalogBtn: "Каталог услуг"
};
